import {
  productFamilyImageIdFormat,
  productImageIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const updateImageDefaults = {
  name: "updateImageDefaults" as const,
  input: z.object({
    updates: z.array(
      z.object({
        imageId: z.union([
          productFamilyImageIdFormat.schema,
          productImageIdFormat.schema,
        ]),
        imageType: z.enum(["productFamily", "product"]),
        isDefault: z.boolean(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
